/*
create

usage:
object-argument:
window.CORE.control.create({
    type: 'div',
    class: 'an_example other_class',
    id: null,
    other: 'other_attribute',
    other2: 'yet_other'
});
list-argument:
window.CORE.control.create('div','some classes','some_id')

return:
a dom node with attributes
*/

let node;

function createNode(type) {
	let elm;
	if (type === 'svg' || type === 'use' || type === 'path' || type === 'g') {
		elm = document.createElementNS('http://www.w3.org/2000/svg', type);
	} else {
		elm = document.createElement(type);
	}
	return elm;
}

function addProperties(p, classname, id) {
	if (typeof p === 'object') {
		Object.keys(p).forEach((key) => {
			if (key !== 'type' && key !== 'input-type' && key !== 'xlink:href') {
				node.setAttribute(key, p[key]);
			} else if (key === 'input-type') {
				node.setAttribute('type', p[key]);
			} else if (key === 'xlink:href') {
				node.setAttributeNS('http://www.w3.org/1999/xlink', 'href', p[key]);
			}
		});
	} else {
		if (classname) {
			node.setAttribute('class', classname);
		}
		if (id) {
			node.setAttribute('id', id);
		}
	}
}

export default {
	basicElement(p, classname, id) {
		const type = (p.type || p);
		node = createNode(type);
		addProperties(p, classname, id);
		return node;
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/common/lib/utils/create.js